import React from 'react'

import PropTypes from 'prop-types'
import { useConnect } from 'redux-bundler-hook'

import { datePropType, idPropType, regexPropType } from '~/src/Lib/PropTypes'
import { getDateTime, parseDuration } from '~/src/Lib/Utils'

import Base from './Base'

export const formatLightSchedule = dataToFormat => {
  const {
    annotation: { startTime, duration, startDate, endDate, phase },
    entities: { phases, harvests },
  } = dataToFormat

  const durationHours = parseDuration(duration)
  const hours = Math.floor(durationHours)
  const minutes = Math.floor((durationHours % 1) * 60)

  let harvestName
  let phaseName
  if (phase && phases) {
    const phaseEntity = phases[phase]
    phaseName = phaseEntity?.name
    if (phaseEntity && harvests) {
      const harvestEntity = harvests[phaseEntity.harvestId]
      harvestName = harvestEntity?.name
    }
  }

  return {
    title: `Lights on at ${getDateTime(`${startDate}T${startTime}`).toLocaleString({
      hour: 'numeric',
      minute: 'numeric'
    })} for ${hours} hours${minutes ? `, ${minutes} minutes` : ''}`,
    body: harvestName || phaseName ? [harvestName, phaseName].filter(Boolean).join(' - ') : undefined,
    date: startDate ? [startDate, endDate].filter(Boolean) : null,
  }
}

export const LightScheduleFormatter = props => {
  const { title, body, date } = formatLightSchedule(props)

  return (
    <Base
      {...props}
      title={title}
      body={body}
      date={date}
    />
  )
}

const hourPattern = /\d{2}:\d{2}:\d{2}/
LightScheduleFormatter.propTypes = {
  annotation: PropTypes.shape({
    duration: regexPropType(hourPattern),
    startTime: regexPropType(hourPattern),
    startDate: datePropType,
    endDate: datePropType,
    phase: idPropType.nullable,
  }).isRequired,
  entities: PropTypes.shape({
    harvests: PropTypes.objectOf(PropTypes.shape({
      name: PropTypes.string,
    })).isRequired,
    phases: PropTypes.objectOf(PropTypes.shape({
      name: PropTypes.string,
      harvestId: idPropType,
    })).isRequired,
  }).isRequired,
}

LightScheduleFormatter.displayName = 'Annotation/LightSchedule'

export default React.memo(props => {
  const connectedProps = useConnect('selectEntities')
  return <LightScheduleFormatter {...props} {...connectedProps} />
})
